import { combineReducers } from 'redux'
import parameters from './parameters'
import results from "./results";

export default combineReducers({
  parameters,
  results
})
